module.exports = __webpack_public_path__ + "img/R. Yehoshua Benzadon.4563405f.png";